import React, { useEffect, useMemo, useState, useRef } from 'react';
import './projectPage.css';
import DOMPurify from "dompurify";
import PageHeader from "../../layouts/home/PageHeader";
import { Col, Container, Image, Row } from "react-bootstrap";
import Categories from "../../components/accesories/sideElements/Categories";
import RecentBlogs from "../../components/accesories/sideElements/RecentBlogs";
import KeyWords from "../../components/accesories/sideElements/KeyWords";
import { Link, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/effect-fade';

// Import required modules
import { FreeMode, Navigation, Thumbs, EffectFade } from 'swiper/modules';
import apiRequest from "../../services/Axios/Configs/configs";
import { useData } from "../../context/DataContext";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { Thumbnails } from "yet-another-react-lightbox/plugins";
import useHandleRequest from "../../custom_hooks/useHandleRequest";

function ProjectPage(props) {
    const { id } = useParams('id');
    const [project, setProject] = useState({ images: [], category: {} });
    const [categories, setCategories] = useState([]);
    const { data, fetchData } = useData();
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [openLightbox, setOpenLightbox] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const thumbnailsRef = useRef(null);
    const [latestProjects, setLatestProjects] = useState([]);

    // دریافت دسته‌بندی‌ها
    useEffect(() => {
        if (data.projectCategories.length === 0) {
            fetchData("projectCategories", 'project-category/');
        } else {
            setCategories(data.projectCategories);
        }
    }, [data.projectCategories]);

    // دریافت پروژه فعلی
    useEffect(() => {
        apiRequest.get(`/project/${id}/`)
            .then(response => {
                setProject(response.data);
            })
            .catch(error => console.error(error));
    }, [id]);

    /*// دریافت پروژه‌های اخیر
    useEffect(() => {
        if (data.latestProjects.length === 0) {
            fetchData("latestProjects", `project/latest-projects/`);
        } else {
            setLatestProjects(data.latestProjects);
        }
    }, [data.latestProjects]);*/

    // ریست کردن state مربوط به thumbsSwiper هنگام تغییر پروژه
    useEffect(() => {
        setThumbsSwiper(null);
    }, [project.id]);

    // مدیریت استایل بدنه در هنگام باز بودن لایت‌باکس
    useEffect(() => {
        if (openLightbox) {
            document.body.style.paddingRight = '15px';
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.paddingRight = '';
            document.body.style.overflow = '';
        }
    }, [openLightbox]);

    // تبدیل رشته کلیدواژه‌ها به آرایه
    const keywords = useMemo(() => {
        return project.keywords ? project.keywords.split("،").map(item => item.trim()) : [];
    }, [project.keywords]);

    // باز و بسته کردن لایت‌باکس
    const openImage = (index) => {
        setCurrentIndex(index);
        setOpenLightbox(true);
    };

    const closeLightbox = () => {
        setOpenLightbox(false);
    };

    return (
        <>
            <PageHeader
                mainTitle={project.title}
                currentPage={project.title}
                navigationLinks={[
                    { title: 'صفحه اصلی', href: '/' },
                    { title: 'پروژه‌ها', href: '/projects' }
                ]}
            />
            <Container className={'project-content-container p-md-5'} fluid>
                <Row className={'content-main-row flex-column-reverse flex-lg-row'}>
                    <Col xl={3} lg={4} sm={12} className={'content-right-col'}>
                        <Col className={'mt-3'} sm={12}>
                            <Categories bgColor={"#fff6d4"} categories={categories} directory={'projects'} />
                        </Col>
                        {/*<Col className={'mt-3'} sm={12}>
                            <RecentBlogs blogs={latestProjects} isBlog={false} />
                        </Col>*/}
                        <Col className={'mt-3'} sm={12}>
                            <KeyWords keywords={keywords} />
                        </Col>
                    </Col>
                    <Col xl={9} lg={8} sm={12} className={'content-left-col'}>
                        <Row className={'project-page-content mb-5 p-1 p-md-4'}>
                            <div className={'project-page-image-wrapper'}>
                                { Array.isArray(project.images) && project.images.length > 0 &&
                                    (<Swiper
                                        key={`main-swiper-${project.id}-${project.images.length}`}
                                        style={{
                                            '--swiper-navigation-color': '#fff',
                                            '--swiper-pagination-color': '#fff',
                                        }}
                                        loop={true}
                                        spaceBetween={10}
                                        navigation={true}
                                        effect={'fade'}
                                        fadeEffect={{ crossFade: true }}
                                        thumbs={{ swiper: thumbsSwiper }}
                                        speed={800}
                                        modules={[FreeMode, Navigation, Thumbs, EffectFade]}
                                        className="mySwiper2"
                                    >
                                        {project.images.map((image, index) => (
                                            <SwiperSlide key={image.id}>
                                                <Image
                                                    src={image.image_url}
                                                    alt={image.image_description}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        openImage(index);
                                                    }}
                                                />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>)

                                }
                                {Array.isArray(project.images) && project.images.length > 0 &&
                                    (
                                        <Swiper
                                            key={`thumb-swiper-${project.id}-${project.images.length}`}
                                            onSwiper={setThumbsSwiper}
                                            loop={true}
                                            spaceBetween={10}
                                            slidesPerView={4}
                                            freeMode={true}
                                            watchSlidesProgress={true}
                                            modules={[FreeMode, Navigation, Thumbs]}
                                            className="mySwiper"
                                        >
                                            {project.images.map(image => (
                                                <SwiperSlide key={image.id}>
                                                    <Image src={image.image_url} alt={image.image_description} />
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    )
                                }
                            </div>
                            <div className={'project-page-detail-wrapper my-4'}>
                                <p className={'m-0'}>
                                    تاریخ تکمیل:
                                    <span className={'d-flex flex-row-reverse me-1'}>{project.completion_date}</span>
                                </p>
                                {project.category?.id && (
                                    <Link to={`/projects/category/${project.category.id}/posts`}>
                                        {project.category.title}
                                    </Link>
                                )}
                            </div>
                            <div className="project-page-description-wrapper">
                                <h1 className={'mb-4'}>{project.title}</h1>
                                <div
                                    className="plog-page-description"
                                    dangerouslySetInnerHTML={{ __html: project.description }}
                                />
                            </div>
                        </Row>
                    </Col>
                </Row>
                {Array.isArray(project.images) && project.images.length > 0 &&
                    (
                        <Lightbox
                            plugins={[Thumbnails]}
                            thumbnails={{ ref: thumbnailsRef }}
                            on={{
                                click: () => {
                                    if (thumbnailsRef.current?.visible) {
                                        thumbnailsRef.current?.hide?.();
                                    } else {
                                        thumbnailsRef.current?.show?.();
                                    }
                                },
                            }}
                            open={openLightbox}
                            close={closeLightbox}
                            slides={project.images.map(img => ({ src: img.image_url }))}
                            index={currentIndex}
                            controller={{
                                closeOnBackdropClick: true,
                            }}
                            carousel={{ finite: true }}
                        />
                    )
                }

            </Container>
        </>
    );
}

export default ProjectPage;
